import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/sessions/tree-bare.png'
import _imports_1 from '../../assets/sessions/leaf-1.png'
import _imports_2 from '../../assets/sessions/leaf-2.png'
import _imports_3 from '../../assets/sessions/leaf-3.png'
import _imports_4 from '../../assets/sessions/leaf-4.png'
import _imports_5 from '../../assets/sessions/leaf-5.png'
import _imports_6 from '../../assets/sessions/leaf-6.png'
import _imports_7 from '../../assets/sessions/leaf-7.png'
import _imports_8 from '../../assets/sessions/leaf-8.png'
import _imports_9 from '../../assets/sessions/leaf-9.png'
import _imports_10 from '../../assets/sessions/roots-black.png'


const _hoisted_1 = {
  class: "tree-wrapper",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  class: "tree-wrapper-inner",
  style: {"padding-bottom":"132.926829268%","width":"100%","position":"relative"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "Gyre Leadership Roots",
  style: {"width":"170%","margin-left":"-35%","margin-right":"-35%"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { computed, ref } from "vue";
import { Power4, TimelineLite, TimelineMax } from "gsap";


export default /*#__PURE__*/_defineComponent({
  __name: 'tree-visual-with-roots',
  setup(__props, { expose: __expose }) {

function leafStyle(left: number, top: number, width: number, height: number): string {
  const treeW = 410;
  const treeH = 545;
  return `
    position: absolute;
    left: ${(left / treeW) * 100}%;
    top: ${(top / treeH) * 100}%;
    width: ${(width / treeW) * 100}%;
    height: ${(height / treeH) * 100}%;
    opacity: 0;
`;
}

// template refs
const treeVisual = ref<HTMLElement | null>(null);
const tree = ref<HTMLElement | null>(null);
const treeImage = ref<HTMLElement | null>(null);
const leaf1 = ref<HTMLElement | null>(null);
const leaf2 = ref<HTMLElement | null>(null);
const leaf3 = ref<HTMLElement | null>(null);
const leaf4 = ref<HTMLElement | null>(null);
const leaf5 = ref<HTMLElement | null>(null);
const leaf6 = ref<HTMLElement | null>(null);
const leaf7 = ref<HTMLElement | null>(null);
const leaf8 = ref<HTMLElement | null>(null);
const leaf9 = ref<HTMLElement | null>(null);
const rootsWrapper = ref<HTMLElement | null>(null);

const leaves = computed(() => {
  return [
    leaf1.value,
    leaf2.value,
    leaf3.value,
    leaf4.value,
    leaf5.value,
    leaf6.value,
    leaf7.value,
    leaf8.value,
    leaf9.value,
  ];
});

const enter = (tl: TimelineMax): void => {
  tl.to(treeVisual.value as HTMLElement, 0, { autoAlpha: 1, scale: 1 })
    .to(
      tree.value as HTMLElement,
      1,
      {
        autoAlpha: 1,
        ease: Power4.easeOut,
      },
      0,
    )
    .to(leaves.value, 0, { scale: 0 })
    .to(leaves.value, 1, { autoAlpha: 1, ease: Power4.easeOut, scale: 1 });
};

const leave = (tl: TimelineMax, scale?: number): void => {
  tl.to(
    treeVisual.value as HTMLElement,
    1,
    { autoAlpha: 0, ease: Power4.easeOut, scale: (scale ?? 1) * 0.8 },
    0,
  );
};

const fadeIn = (tl: TimelineMax, explicitScale?: number, explicitYPercent?: number): void => {
  const scale = explicitScale ?? 1;
  const yPercent = explicitYPercent ?? 0;
  tl.to(treeVisual.value as HTMLElement, 0, {
    scale: scale * 0.8,
    autoAlpha: 0,
    yPercent,
  })
    .to(leaves.value, 0, { scale: 1, autoAlpha: 1 })
    .to(
      treeVisual.value as HTMLElement,
      1,
      {
        autoAlpha: 1,
        ease: Power4.easeOut,
        scale,
        yPercent,
      },
      "+=0.1",
    );
};

const fadeOut = (tl: TimelineMax): TimelineLite =>
  tl.to(treeVisual.value as HTMLElement, 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);

__expose({ enter, leave, fadeIn, fadeOut });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "treeVisual",
    ref: treeVisual,
    class: "visual side-visual tree-visual"
  }, [
    _createElementVNode("div", {
      style: {"margin":"0 auto"},
      ref_key: "tree",
      ref: tree
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            ref_key: "treeImage",
            ref: treeImage,
            class: "tree",
            src: _imports_0,
            alt: "Gyre Leadership Tree",
            style: {"width":"100%","position":"absolute"}
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "leaf1",
            ref: leaf1,
            src: _imports_1,
            style: _normalizeStyle(leafStyle(60, 321, 66, 56)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf2",
            ref: leaf2,
            src: _imports_2,
            style: _normalizeStyle(leafStyle(0, 208, 81, 69)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf3",
            ref: leaf3,
            src: _imports_3,
            style: _normalizeStyle(leafStyle(24, 100, 81, 82)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf4",
            ref: leaf4,
            src: _imports_4,
            style: _normalizeStyle(leafStyle(166, 0, 98, 110)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf5",
            ref: leaf5,
            src: _imports_5,
            style: _normalizeStyle(leafStyle(258, 96, 105, 114)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf6",
            ref: leaf6,
            src: _imports_6,
            style: _normalizeStyle(leafStyle(346, 240, 64, 49)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf7",
            ref: leaf7,
            src: _imports_7,
            style: _normalizeStyle(leafStyle(283, 320, 66, 52)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf8",
            ref: leaf8,
            src: _imports_8,
            style: _normalizeStyle(leafStyle(136, 247, 53, 61)),
            alt: ""
          }, null, 4),
          _createElementVNode("img", {
            ref_key: "leaf9",
            ref: leaf9,
            src: _imports_9,
            style: _normalizeStyle(leafStyle(122, 132, 70, 94)),
            alt: ""
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", {
        ref_key: "rootsWrapper",
        ref: rootsWrapper,
        class: "roots-wrapper"
      }, _hoisted_4, 512)
    ], 512)
  ], 512))
}
}

})